import React from 'react';
import { Stack } from '@mui/material';
import Installments from './common/installments';
import CardType from './common/cardType';
import CardBrand from './common/cardBrand';
import CardBankIcon from './common/cardBankIcon';
import CardBankTitle from './common/cardBankTitle';

const CardPaymentMethod = ({ paymentOption }) => {
  return (
    <Stack className="methodLabel">
      <CardBankIcon bank={paymentOption?.bank} />
      <Stack direction="column" gap={0}>
        <CardBankTitle bank={paymentOption?.bank} />
        <Stack direction="row" gap={0.5}>
          <Installments installments={paymentOption?.installments} />
          <CardType cardType={paymentOption?.cardType} />
        </Stack>
        <CardBrand cardBrand={paymentOption?.cardBrand} />
      </Stack>
    </Stack>
  );
};

export default CardPaymentMethod;
